function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 3,
  width: 26,
  height: 26,
  rx: 3,
  fill: "#E1E8F2"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 8a1 1 0 112 0v2.083a5.966 5.966 0 012.477 1.026l1.473-1.473a1 1 0 011.414 1.414l-1.473 1.473A5.966 5.966 0 0121.917 15H24a1 1 0 110 2h-2.083a5.966 5.966 0 01-1.026 2.477l1.473 1.473a1 1 0 01-1.414 1.414l-1.473-1.473A5.966 5.966 0 0117 21.917V24a1 1 0 11-2 0v-2.083a5.966 5.966 0 01-2.476-1.026l-1.474 1.473a1 1 0 01-1.414-1.414l1.473-1.473A5.966 5.966 0 0110.083 17H8a1 1 0 110-2h2.083a5.966 5.966 0 011.026-2.476L9.636 11.05a1 1 0 011.414-1.414l1.473 1.473A5.966 5.966 0 0115 10.083V8z",
  fill: "url(#settings_svg__paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 13,
  y: 13,
  width: 6,
  height: 6,
  rx: 3,
  fill: "#E1E8F2"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "settings_svg__paint0_linear",
  x1: 10.375,
  y1: 7,
  x2: 24.419,
  y2: 10.212,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})));

var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgSettings;